export default __webpack_public_path__ + "media/images/images_v2/entete3-0158ab4fb1228c7dee5600e85bb1bdd9.png";